module.exports = __webpack_public_path__ + "img/yvzhou.7200afcb.png";